// extracted by mini-css-extract-plugin
export default {"imgdiv":"aca074fc68 _556d2d14bd","img":"_6dc94e9e0b _07600f3311"};